import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import React, { useState } from 'react'

export function AdvisorSelect<T extends { name: string }>({
    advisors,
    onCreate,
    onSelect,
    label,
}: {
    advisors: T[]
    onCreate: (advisor: { name: string }) => void
    onSelect: (advisor: T) => void
    label: string
}) {
    const [inputValue, setInputValue] = useState('')

    return (
        <Autocomplete<T, false, false, true>
            autoHighlight
            freeSolo
            fullWidth
            options={advisors}
            getOptionLabel={(option) => (option === null ? '' : typeof option === 'string' ? option : option.name)}
            inputValue={inputValue}
            onInputChange={(_event, newInputValue, reason) => {
                if (reason === 'input') {
                    setInputValue(newInputValue)
                }
            }}
            renderInput={(params) => <TextField {...params} label={label} />}
            onChange={(_event, newValue, reason) => {
                if (reason === 'selectOption' && newValue !== null && typeof newValue !== 'string') {
                    onSelect(newValue)
                    setInputValue('')
                    return
                }
                if (reason == 'createOption' && typeof newValue === 'string') {
                    const cleanedAdvisorName = newValue.trim()
                    onCreate({ name: cleanedAdvisorName })
                    setInputValue('')
                }
            }}
        />
    )
}
